<template lang="html">
  <v-container fluid style="position: absolute">
    <transition name="dialog_slide">
      <router-view/>
    </transition>
    <InfoBox
        v-if="show_info_box"
        @clickOutside="closeInfoBox()"
        >
        <template #button-top>
          <WaggonInfoNavButton
            v-if="showUp()"
            direction="up"
            width="80px"
            @click.native="routeUp()"
            />
        </template>
        <template #button-right>
          <WaggonInfoNavButton
            v-if="showRight()"
            direction="right"
            height="80px"
            @click.native="routeRight()"
            />
        </template>
        <template #button-bottom>
          <WaggonInfoNavButton
            v-if="showDown()"
            direction="down"
            width="80px"
            @click.native="routeDown()"
            />
        </template>
        <template #button-left>
          <WaggonInfoNavButton
            v-if="showLeft()"
            direction="left"
            height="80px"
            @click.native="routeLeft()"
            />
        </template>
        <template #default>
        <WaggonInfo
          :waggon="{}"
          >
          <template #header>
            <WaggonInfoHeader
              v-for="(work_package, index) in work_packages_large"
              :key="'header' + work_package.id"
              :width="'100%'"
              :color="work_package.color"
              :text="work_package.token"
              :icon="work_package.icon"
              @click.native="changeWPLarge(index)"
              />
          </template>
          <template #body>
            <template v-if="show_info_box_body === 'info'">
              <WaggonInfoBody
                :color="work_packages_large[work_packages_large_index].color"
                :work_package="work_packages_large[work_packages_large_index]"
                :info_box="true"
                >
                <template #body-content="body_slot">
                  <StandardDataField
                    :value="body_slot.work_package.name"
                    readonly="true"
                    />
                  <StandardDataField
                    :value="body_slot.work_package.description"
                    flat="true"
                    placeholder="description"
                    :resizable="true"
                    :readonly="true"
                    />
                  <v-divider color="black"></v-divider>
                    <StandardFlexBox>
                      <!-- attributes planned -->
                      <StandardFlexBox
                        class="pa-1"
                        width="50%"
                        direction="column"
                        >
                        attributes planned
                        <StandardFlexBox>
                          <StandardDataField
                          :value="body_slot.work_package.time_effort_planned"
                          icon="speed"
                          width="28%"
                          :type="'number'"
                          :readonly="true"
                          />
                          <div style="width: 8%; line-height: 33px; text-align: center;">/</div>
                          <StandardDataField
                            :value="body_slot.work_package.manpower_planned"
                            icon="accessibility"
                            width="28%"
                            :type="'number'"
                            :readonly="true"
                            />
                          <div style="width: 8%; line-height: 33px; text-align: center;">=</div>
                          <StandardDataField
                            :value="body_slot.work_package.manpower_planned === 0 || isNaN(Math.round((body_slot.work_package.time_effort_planned/body_slot.work_package.manpower_planned)*100) / 100)?
                                    '':Math.round((body_slot.work_package.time_effort_planned/body_slot.work_package.manpower_planned)*100) / 100"
                            icon="timer"
                            width="28%"
                            :readonly="true"
                            />
                        </StandardFlexBox>
                        <StandardFlexBox>
                          <StandardDataField
                            :value="body_slot.work_package.quantity_value"
                            icon="drag_indicator"
                            width="33%"
                            :type="'number'"
                            :readonly="true"
                            />
                          <StandardDataField
                            :value="body_slot.work_package.quantity_unit"
                            icon="drag_indicator"
                            width="33%"
                            :readonly="true"
                            />
                        </StandardFlexBox>
                      </StandardFlexBox>
                      <!-- attributes actual -->
                      <StandardFlexBox
                        style="border-left: solid 1px black"
                        class="pa-1"
                        width="50%"
                        direction="column"
                        >
                        attributes actual
                        <StandardFlexBox>
                          <StandardDataField
                            :value="body_slot.work_package.manpower_actual === 0?
                                    '':Math.round((body_slot.work_package.duration_actual*body_slot.work_package.manpower_actual)*100) / 100"
                            icon="speed"
                            icon_actual="true"
                            width="28%"
                            :readonly="true"
                            />
                          <div style="width: 8%; line-height: 33px; text-align: center;">=</div>
                          <StandardDataField
                            :value="body_slot.work_package.manpower_actual"
                            icon="accessibility"
                            icon_actual="true"
                            width="28%"
                            :type="'number'"
                            :readonly="true"
                            />
                          <div style="width: 8%; line-height: 33px; text-align: center;">x</div>
                          <StandardDataField
                            :value="body_slot.work_package.duration_actual"
                            icon="timer"
                            icon_actual="true"
                            width="28%"
                            :type="'number'"
                            :readonly="true"
                            />
                        </StandardFlexBox>
                      </StandardFlexBox>
                    </StandardFlexBox>
                  <v-divider color="black"></v-divider>
                  <!-- Contact -->
                  <StandardFlexBox
                    direction="column"
                    :no_wrap="true"
                    >
                    contact
                    <StandardDataField
                      width="100%"
                      :value="body_slot.work_package.contact_name"
                      icon="account_circle"
                      :readonly="true"
                      />
                    <StandardDataField
                      width="100%"
                      :value="body_slot.work_package.contact_phone_number"
                      icon="call"
                      :readonly="true"
                      />
                    <StandardDataField
                      width="100%"
                      :value="body_slot.work_package.contact_email"
                      icon="email"
                      :readonly="true"
                      />
                    </StandardFlexBox>
                </template>
              </WaggonInfoBody>
            </template>
            <template v-if="show_info_box_body === 'worksteps'">
              <WaggonInfoBody
                :color="work_packages_large[work_packages_large_index].color"
                :work_package="work_packages_large[work_packages_large_index]"
                :info_box="true"
                >
                <template #body-content="body_slot">
                  WORK.steps ({{body_slot.work_package.work_steps.length}})
                  <StandardStep
                    v-for="(work_step) in body_slot.work_package.work_steps"
                    :key="'work_step' + work_step.id"
                    :step="work_step"
                    :readonly="true"
                    step_type="worksteps"
                  />
                </template>
              </WaggonInfoBody>
            </template>
            <template v-if="show_info_box_body === 'qualitysteps'">
              <WaggonInfoBody
                :color="work_packages_large[work_packages_large_index].color"
                :work_package="work_packages_large[work_packages_large_index]"
                :info_box="true"
                >
                <template #body-content="body_slot">
                  QUALITY.steps ({{body_slot.work_package.quality_steps.length}})
                  <StandardStep
                    v-for="(quality_step) in body_slot.work_package.quality_steps"
                    :key="'quality_step' + quality_step.id"
                    :step="quality_step"
                    :readonly="true"
                    step_type="qualitysteps"
                  />
                </template>
              </WaggonInfoBody>
            </template>
            <template v-if="show_info_box_body === 'defectsteps'">
              <WaggonInfoBody
                :color="work_packages_large[work_packages_large_index].color"
                :work_package="work_packages_large[work_packages_large_index]"
                :info_box="true"
                >
                <template #body-content="body_slot">
                  DEFECT.steps ({{body_slot.work_package.defect_steps.length}})
                  <StandardStep
                    v-for="(defect_step) in body_slot.work_package.defect_steps"
                    :key="'defect_step' + defect_step.id"
                    :step="defect_step"
                    :readonly="true"
                    step_type="defectsteps"
                  />
                </template>
              </WaggonInfoBody>
            </template>
            <template v-if="show_info_box_body === 'nosteps'">
              <WaggonInfoBody
                :color="work_packages_large[work_packages_large_index].color"
                :work_package="work_packages_large[work_packages_large_index]"
                :info_box="true"
                >
                <template #body-content="body_slot">
                  <StandardFlexBox
                    direction="column"
                    align_content="center"
                    justify_content="center"
                    height="calc(100% - 36px)"
                    >
                    <div
                      :class="`mb-1 ${body_slot.work_package.color}--text text--darken-3 font-weight-medium`"
                      v-if="!body_slot.work_package.work_steps ||
                          body_slot.work_package.work_steps.length === 0"
                      >
                      ... no WORK.steps created
                    </div>
                    <div
                      :class="`mb-1 ${body_slot.work_package.color}--text text--darken-3 font-weight-medium`"
                      v-if="!body_slot.work_package.quality_steps ||
                          body_slot.work_package.quality_steps.length === 0"
                      >
                      ... no QUALITY.steps created
                    </div>
                    <div
                      :class="`mb-1 ${body_slot.work_package.color}--text text--darken-3 font-weight-medium`"
                      v-if="!body_slot.work_package.defect_steps ||
                          body_slot.work_package.defect_steps.length === 0"
                      >
                      ... no DEFECT.steps created
                    </div>
                    <div
                      :class="`mb-1 ${body_slot.work_package.color}--text text--darken-3 font-weight-medium`"
                      v-if="!body_slot.work_package.handover_steps ||
                          body_slot.work_package.handover_steps.length === 0"
                      >
                      ... no Handover.steps created
                    </div>
                  </StandardFlexBox>
                </template>
              </WaggonInfoBody>
            </template>
          </template>
        </WaggonInfo>
      </template>
    </InfoBox>
    <v-row>
      <v-col cols="12" xs12>
        <v-card class="color-2 ma-4 pa-4">
          <v-row>
            <v-col cols="2" xs2>
              <SequenceEditorDialog :sequence_editor_dialog="sequence_editor_dialog" />
              <v-btn
                @click="$router.push({
                  name: 'WorkBenchSequenceEditor',
                  params: {sequence_id: 'create'}
                  })"
                >
                create sequence new editor
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="getSequences.length === 0" align="center" justify="center">
      <v-col cols="10" align="center" justify="center">
        <v-alert type="info">
          You don't have any Sequences yet.
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="getSequences.length > 0">
      <v-col cols="12">
        <div class="text-center">
          <v-pagination
            v-model="page"
            :length="Math.ceil(getPagination.total / getPagination.limit)"
            :total-visible="7"
            circle
            @input="changePage($event)"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="getSequences.length > 0">
      <v-col cols="12" xs12 v-for="sequence in getSequences" :key="sequence.id">
        <v-card
          class="color-2 ma-4 pa-4"
          @click="$router.push({
            name: 'WorkBenchSequenceEditor',
            params: {
              sequence_id: sequence.id
              }
            })"
          >
          <v-row>
            <v-col cols="12" xs12>
              <SequenceHeaderDetails :sequence="sequence" />
                <div class="sequence-card">
                  <TrainHead />
                  <v-hover
                    v-for="waggon in sequence.waggons"
                    :key="waggon.id"

                    >
                    <Waggon
                      slot-scope="{ hover }"
                      :workpackage_count="waggon.work_packages.length"
                      @click.native="clickWaggon(waggon.work_packages)"
                      >
                      <template #content>
                        <StandardHover v-if="hover"/>
                        <v-hover
                          v-for="workpackage in waggon.work_packages"
                          :key="workpackage.id"
                          >
                          <WorkPackage
                            :color="workpackage.color"
                            :icon="workpackage.icon"
                            :token="workpackage.token"
                            :workpackage_count="waggon.work_packages.length"
                            >
                          </WorkPackage>
                        </v-hover>
                      </template>
                    </Waggon>
                  </v-hover>
                  <TrainTail />
                </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8" xs10>
              <StandardOwnerDetails :owner="sequence.owner" />
            </v-col>
            <v-col cols="4">
              <CommunitySuggestBtn class="pull-right" :el="sequence" @communitSuggestClick="suggestSToCommunity(sequence)" />
              <StandardDeleteBtn :btnclass="'pull-right'" :el="sequence" @deleteClick="deleteS(sequence)" />
              <SequenceUpdateEditorDialog :sequence="sequence" />
              <!-- <StandardEditBtn class="pull-right" :el="sequence" @deleteClick="editWS(sequence)" /> -->
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="getSequences.length > 0">
      <v-col cols="12">
        <div class="text-center">
          <v-pagination
            v-model="page"
            :length="Math.ceil(getPagination.total / getPagination.limit)"
            :total-visible="7"
            circle
            @input="changePage($event)"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { WorkPackageLargeMixin } from '@/mixins/WorkPackageLarge.mixin.js';

import SequenceHeaderDetails from '@/components/Sequences/SequenceHeaderDetails.component.vue';
import SequenceEditorDialog from '@/components/Sequences/SequenceEditorDialog.component.vue';
import SequenceUpdateEditorDialog from '@/components/Sequences/SequenceUpdateEditorDialog.component.vue';

import StandardOwnerDetails from '@/components/StandardComponents/StandardOwnerDetails.component.vue';
import StandardDeleteBtn from '@/components/StandardComponents/StandardDeleteBtn.component.vue';
import CommunitySuggestBtn from '@/components/Community/CommunitySuggestBtn.component.vue';

import TrainHead from '@/components/ProjectTaktPlan/TrainHead.component.vue';
import Waggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
import StandardHover from '@/components/StandardComponents/StandardHover.component.vue';
import TrainTail from '@/components/ProjectTaktPlan/TrainTail.component.vue';


import store from '@/store/index';
import {
  mapGetters,
  mapActions
} from 'vuex';
export default {
  name: 'CustomSequences',
  components: {
    SequenceHeaderDetails,
    StandardOwnerDetails,
    SequenceUpdateEditorDialog,
    StandardDeleteBtn,
    SequenceEditorDialog,
    TrainHead,
    Waggon,
    WorkPackage,
    StandardHover,
    TrainTail,
    CommunitySuggestBtn
  },
  mixins: [
    WorkPackageLargeMixin
  ],
  data: function() {
    return {
      page: 1,
      sequence_editor_dialog: false
    }
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch('Sequence/requestCustomSequences').then(res => next(res));
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === 'CustomSequence') {
      store.dispatch('Sequence/requestCustomSequences').then(res => next(res));
    } else {
      next();
    }
  },
  created() {
    if (this.$route.query.editor) {
      this.sequence_editor_dialog = true;
    }
  },
  computed: {
    ...mapGetters('Sequence', [
      'getSequences',
      'getPagination',
      'isLoading'
    ])
  },
  methods: {
    ...mapActions('Sequence', [
      'suggestToCommunity',
      'requestCustomSequences',
      'deleteSequence'
    ]),
    changePage(page){
      this.page = page;
      this.requestCustomSequences(page);
    },
    suggestSToCommunity(sequence){
      this.suggestToCommunity(sequence.id);
    },
    deleteS(sequence){
      this.deleteSequence(sequence.id);
    }
  }
}
</script>

<style lang="css" scoped>
  .sequence-card {
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    width: 100%;
  }
  /* .dialog_slide-enter, .dialog_slide-leave-to {
    transform: translateY(100vh);
  }
  .dialog_slide-enter-active, .dialog_slide-leave-active {
    transition: transform 0.2s ease-in-out;
  } */
</style>
